var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DashboardTemplate',[_c('p',{staticClass:"title is-size-4-tablet is-size-5-mobile has-text-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t("smartReport.smartReportHeader"))+" ")]),_c('ReportCompanyList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }